import {NgForOf, NgIf} from "@angular/common";
import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {FlexModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {MatDialog} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatTooltipModule} from "@angular/material/tooltip";
import {generateUuid} from "@ui-kit/framework/util/static/uuid-utils";
import {ImageCarouselComponent} from "@ui-kit/webkit/components/image-carousel/image-carousel.component";
import {DocumentFile} from "@ui-kit/webkit/components/image-carousel/image-carousel.model";
import {AppSharedModule} from "../../../../../../soko-console-web-v2/src/app/core/modules/app-shared.module";

import JSZip from 'jszip';

@Component({
  selector: 'app-image-grid',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    FlexModule,
    NgIf,
    NgForOf,
    MatMenuModule,
    AppSharedModule
  ],
  templateUrl: './image-grid.component.html',
  styleUrl: './image-grid.component.scss'
})
export class ImageGridComponent implements OnChanges {
  @Input() imageFiles: DocumentFile[] = [];
  @Input() allowDelete: boolean = false;
  @Input() allowAdd: boolean = false;
  @Input() allowDownload: boolean = false;
  @Input() isLoading = false;
  @Input() hasMoreImagesToLoad = false;
  @Input() heading?: string;
  @Input() subHeading?: string;
  @Input() filePrefix: string = 'nter_images';

  @Output() addImage = new EventEmitter<void>();
  @Output() deleteImage = new EventEmitter<string>();
  @Output() loadMoreImages = new EventEmitter<void>();

  imageToDelete: string | null = null;

  constructor(private matDialog: MatDialog) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["imageFiles"]) {
      this.imageFiles = changes["imageFiles"].currentValue;
    }
  }

  openImageCarousel(index: number) {
    this.matDialog.open(ImageCarouselComponent, {
      data: {
        images: this.imageFiles,
        currentIndex: index
      },
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      panelClass: 'image-carousel-dialog'
    });
  }

  downloadImage(image: DocumentFile) {
    const a = document.createElement('a');
    a.href = image.fileUrl;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async downloadImages() {
    const zip = new JSZip();

    const fetchPromises = this.imageFiles.map(async (image, index) => {
      const response = await fetch(image.fileUrl);
      const blob = await response.blob();
      const extension = blob.type.split('/')[1] || 'jpg';
      const fileName = image.fileName || `image_${index + 1}.${extension}`;
      zip.file(fileName, blob);
    });

    await Promise.all(fetchPromises);

    const zipBlob = await zip.generateAsync({ type: 'blob' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(zipBlob);
    a.download = `${this.filePrefix}_${generateUuid()}.zip`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  }

  triggerDeleteImage(imageId: string) {
    this.imageToDelete = imageId;
  }

  addNewImage() {
    this.addImage.emit();
  }

  emitDeleteImage() {
    if (this.imageToDelete) {
      this.deleteImage.emit(this.imageToDelete);
      this.imageToDelete = null;
    }
  }
}
